import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

const Header = ({ context }) => {
	
	const ctxGlobal 		= () => context.global;
	const global 			= ctxGlobal();
	
	const ctxSiteEndLoaded 	= () => context.siteEndLoaded;
    const siteEndLoaded 	= ctxSiteEndLoaded();
    
    const ctxMenuOpen 		= () => context.menu.open;
    const menuOpen 			= ctxMenuOpen();
    
	const ctxBgColor 		= () => context.bgColor;
    const bgColor 			= ctxBgColor();
    
    const ctxHeaderStyle 	= () => context.headerStyle;
    const headerStyle 		= ctxHeaderStyle();
    
    const posts 			= () => context.posts;
    const post 				= posts()[0];
	
	function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
			
    if (context.global) {
							
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/mim-design/v1/global');
		}
	  		  	
	  	if (global.json !== null) {  
		  	
		  	let headerClass = 'c-header';
		  	let menuClass = 'c-menu';
		  	
		  	headerClass = headerClass + ' c-header--' + headerStyle
	    	
	    	if (menuOpen === true) {
		    	headerClass = headerClass + ' state-menu-open';
		    	menuClass 	= menuClass + ' state-menu-open';
	    	}
	    	
	    	if (siteEndLoaded) {
		    	headerClass = headerClass + ' state-site-loaded'
	    	}
	    	
			if (bgColor === 'black') {
				headerClass = headerClass + ' scope-black-bg';
	    	}
	    	
	    	if (bgColor === 'grey') {
				headerClass = headerClass + ' scope-grey-bg';
	    	}
	    	
	    	const items = [];
	    	for (let i=0;i<global.json.menu.length;i++) {
		    	let itemClass = "c-menu__link";
		    	if (window.location.pathname + '' === global.json.menu[i].url) {
			    	items.push(<li className="c-menu__item" data-index={i} key={i}><a href="#" onClick={handleMenuToggle} className={ itemClass }>{ global.json.menu[i].title }</a></li>);	
		    	} else {
					items.push(<li className="c-menu__item" data-index={i} key={i}><Link to={{ pathname: global.json.menu[i].url }} className={ itemClass }>{ global.json.menu[i].title }</Link></li>);	
				}				
			}
			
			return (
				<>
			    	<header className={headerClass}>
			    		<div className="c-header__inner">
				    		<a href="#" className="c-header__menu-button" onClick={handleMenuToggle}>
								<span>Menu</span>
								<span>Close</span>
							</a>
							<a href="#" className="c-header__mobile-menu-button" onClick={handleMenuToggle}>
								<div className="c-header__mobile-menu-button__line c-header__mobile-menu-button__line--top"></div>
								<div className="c-header__mobile-menu-button__line c-header__mobile-menu-button__line--middle"></div>
								<div className="c-header__mobile-menu-button__line c-header__mobile-menu-button__line--bottom"></div>
							</a>
							<h2 className="c-header__logo">
								<Link to={{ pathname: '/' }} className="c-header__logo__inner" dangerouslySetInnerHTML={{__html:'<svg width="143" height="15" viewBox="0 0 143 15"><path d="M68.707 10.5046C67.8719 11.5568 66.7031 12.1649 65.1362 12.1649H63.0807V2.79313H65.1362C66.7053 2.79313 67.8719 3.40332 68.707 4.45342C69.3613 5.27241 69.7229 6.34683 69.7229 7.48004C69.7229 8.61325 69.3634 9.68564 68.707 10.5067M69.3613 2.02279C68.1926 1.1592 66.828 0.757812 64.8414 0.757812H60.8789V14.2023H64.8414C66.828 14.2023 68.1904 13.8009 69.3613 12.9373C71.0293 11.6946 72.0259 9.65321 72.0259 7.48004C72.0259 5.30687 71.0293 3.26547 69.3613 2.02279Z" fill="black"/><path d="M22.6853 0.757812H20.5352V14.1779H22.6853V0.757812Z" fill="black"/><path d="M85.1281 2.66136H79.4158V5.88462H83.671V7.78817H79.4158V12.2744H85.1281V14.1779H77.2656V0.757812H85.1281V2.66136Z" fill="black"/><path d="M98.3112 2.75658L96.5678 3.72964C96.2406 3.19649 95.9307 2.84983 95.6358 2.68563C95.3281 2.50115 94.932 2.4079 94.4456 2.4079C93.8494 2.4079 93.3544 2.56805 92.9605 2.88632C92.5666 3.19851 92.3707 3.59382 92.3707 4.06819C92.3707 4.72297 92.8873 5.25005 93.9204 5.64941L95.341 6.19676C96.4968 6.63666 97.3426 7.17387 97.8786 7.80839C98.4145 8.4429 98.6814 9.22135 98.6814 10.1417C98.6814 11.3763 98.2445 12.396 97.3706 13.2008C96.4903 14.0116 95.3991 14.4171 94.0948 14.4171C92.8593 14.4171 91.837 14.0725 91.032 13.3832C90.2378 12.694 89.7427 11.7229 89.5469 10.4721L91.725 10.0201C91.824 10.8087 91.9962 11.3519 92.2416 11.654C92.685 12.2338 93.3307 12.5237 94.1787 12.5237C94.8481 12.5237 95.4055 12.3128 95.8489 11.8892C96.2923 11.4655 96.514 10.9303 96.514 10.2816C96.514 10.0201 96.4753 9.78086 96.3978 9.56395C96.3203 9.34704 96.1998 9.14635 96.0383 8.9639C95.8748 8.78145 95.6638 8.61116 95.4055 8.45101C95.1473 8.29086 94.8395 8.13882 94.4822 7.99489L93.1068 7.45565C91.1568 6.67923 90.1818 5.54399 90.1818 4.04791C90.1818 3.04039 90.5908 2.19707 91.4086 1.51796C92.2265 0.834786 93.2446 0.492188 94.4628 0.492188C96.1051 0.492188 97.3878 1.24631 98.3112 2.75253" fill="black"/><path d="M105.947 0.757812H103.797V14.1779H105.947V0.757812Z" fill="black"/><path d="M117.972 7.19558H124.765V7.63954C124.765 8.64706 124.638 9.53903 124.386 10.3155C124.141 11.0331 123.725 11.7061 123.142 12.3305C121.82 13.7313 120.137 14.4327 118.097 14.4327C116.056 14.4327 114.399 13.7556 112.978 12.3994C111.558 11.0392 110.848 9.40524 110.848 7.49966C110.848 5.59408 111.571 3.90339 113.015 2.54921C114.459 1.18895 116.218 0.507812 118.29 0.507812C119.403 0.507812 120.443 0.722697 121.407 1.15044C122.33 1.57818 123.237 2.27351 124.128 3.23441L122.597 4.61494C121.429 3.14927 120.006 2.41744 118.327 2.41744C116.82 2.41744 115.557 2.906 114.537 3.88514C113.517 4.84604 113.006 6.0502 113.006 7.49966C113.006 8.94911 113.575 10.2242 114.713 11.1912C115.777 12.0893 116.93 12.5373 118.172 12.5373C119.229 12.5373 120.18 12.2008 121.022 11.5298C121.863 10.8527 122.335 10.0418 122.434 9.0971H117.974V7.19558H117.972Z" fill="black"/><path d="M12.038 0.75L7.46001 10.1765L3.0391 0.75H2.35896L0 14.1762H2.00813L3.32536 6.06534L7.14361 14.1985H7.70968L11.6399 6.07548L12.8 14.1762H14.7909L12.7139 0.75H12.038Z" fill="black"/><path d="M40.2824 0.75L35.7022 10.1765L31.2813 0.75H30.6033L28.2422 14.1762H30.2525L31.5676 6.06534L35.388 14.1985H35.9519L39.882 6.07548L41.0421 14.1762H43.0331L40.9561 0.75H40.2824Z" fill="black"/><path d="M129.699 0.75V14.1762H131.849V4.78009L141.434 14.1985H142.241V0.756082H140.091V10.0812L130.62 0.75H129.699Z" fill="black"/></svg>'}}></Link>
							</h2>
							
							<a href={global.json.instagram} className="c-header__instagram" target="_blank">Instagram</a>
						</div>
					</header>
					
					<div className={menuClass}>
						<div className="c-menu__inner">
							<ul className="c-menu__list">
								{items}
							</ul>
							<div className="c-menu__footer">
								{global.json.subscribe_form_menu &&
									<div className="scope-subscription-form">
					    				<GravityForm
											backendUrl={document.location.origin + '/wp-json/mim-design/v1/form'}
											formID={global.json.subscribe_form_menu}
										/>
									</div>
								}
								<div className="c-footer__links">
									{global.json.privacy_url &&
										<Link to={{ pathname: global.json.privacy_url }} className="c-menu__footer__privacy">Privacy Policy</Link>
									}
								</div>
							</div>
						</div>
					</div>
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Header);